import { useEffect } from 'react';
import appIcon from '~/assets/img/civilgrid-app-icon.png';
import { APP_STORE_URL, PLAY_STORE_URL } from '~/constants/links';

export default function Download() {
  useEffect(() => {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(ua)) {
      window.location.replace(APP_STORE_URL);
    } else if (/Android/i.test(ua)) {
      window.location.replace(PLAY_STORE_URL);
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f5f5f5',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: '#333',
      }}
    >
      <div style={{ textAlign: 'center', padding: '2rem', maxWidth: 480 }}>
        <img
          src={appIcon}
          alt="CivilGrid"
          style={{
            width: 80,
            height: 80,
            margin: '0 auto 1.5rem',
            borderRadius: 18,
            display: 'block',
          }}
        />
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Get CivilGrid</h1>
        <p
          style={{
            color: '#666',
            marginBottom: '2rem',
            lineHeight: 1.5,
          }}
        >
          Download the CivilGrid mobile app to capture data in the field.
        </p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              style={{ height: 54 }}
            />
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style={{ height: 80, margin: '-13px 0' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
}
